import { useTranslation } from "react-i18next";
import { localPick } from "../../lib/localName";

// قواعد إيقاف الراتب كما هي في إعدادات كل فرع (ديناميكية 100%).
export const HoldRules = ({ rules = [] }) => {
  const { t } = useTranslation();
  return (
    <div className="rounded-3xl border-2 border-amber-300/60 bg-amber-50 p-4 text-xs" data-testid="holds-rules">
      <p className="mb-2 font-black text-amber-800">{t("holds.rulesTitle")}</p>
      <ul className="grid gap-1.5 font-semibold text-amber-900">
        {rules.length === 0 ? (
          <li>• {t("holds.rulesNoBranches")}</li>
        ) : (
          rules.map((r) => (
            <li key={r.branch_id} data-testid={`holds-rule-${r.branch_id}`}>
              • {localPick(r, "branch_name", "—")}:{" "}
              {r.days > 0 ? t("holds.ruleBranch", { count: r.days }) : t("holds.ruleDisabled")}
              {" · "}
              {r.deduct_absence === false
                ? t("holds.ruleNoDeduction")
                : t("holds.ruleDeduction", { count: r.absence_per_day ?? 1 })}
            </li>
          ))
        )}
        <li>• {t("holds.rule3")}</li>
      </ul>
    </div>
  );
};
